module.exports = __webpack_public_path__ + "static/hb-favicon-c4bf4dc67ccbb9c2ca18e3a860f42478.png";